import { normalize as norm, filterByName } from '@/plugins/w@util/accents/index'

export const normalize = (query: String) => norm(query?.trim() ?? '')

export function getTasks(tasks, predicate: Function, showTasks = true): [] {
	return tasks && showTasks ? tasks.filter(task => !task?.completed && (predicate?.(task) ?? true)) : [] // Filter away completed tasks and based on predicate
}

export function search(query: String, projects, showTasks = true): [] {
	if (!projects?.length)
		return []
	
	try {
		projects = JSON.parse(JSON.stringify(projects)) // Clone contents to not affect their original original instance
		return projects.filter(proj => filterByName(proj.name, query) || filterProjectTasks(proj, query, showTasks)) // Search filtering by query matching the name of project
	}
	catch (e) {
		return []
	}
}

function filterProjectTasks(proj, searchQuery: String, showTasks = true) { // Filter away tasks of project based on search query
	return (proj.tasks = getTasks(proj?.tasks, task => filterByName(task.name, searchQuery), showTasks))?.length // Return count of tasks after filtering
}